var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ guacamole: _vm.$route.name === 'Rdp' },attrs:{"id":"app"}},[_c('router-view'),_c('vue-snotify'),_c('MessageModal'),_c('NotificationModal'),_c('ExpiredSessionModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }